const UUID_RE = /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/

/**
 * Tells a category see-more (`dmp.category.<uuid>`) from a strategy name on the
 * shared `/podcasts/:categoryId/:strategyId` route.
 */
export function isPodcastCategorySegment(segment: string): boolean {
    return UUID_RE.test(segment)
}
